import { ServletCmds } from '../../../../../NonReact/constants/ServletCommands'
import {
    INSIGHTS_HUB_ROUTE_PATH,
    MFA_ROUTE_PATH,
    TEAMS_AUTH_ROUTE_PATH,
    TERMS_AND_CONDITIONS_ROUTE_PATH
} from '../../../../Constants/Constants'

export const PASSWORD_POLICY_CONFIG: string = 'passwordPolicyConfig'
export const REVERSION_COMMAND_QUERY_PARAM: string = 'tbReversionServletCmd'

export const DEFAULT_PASSWORD_MIN_LENGTH: number = 8

export const NAME_MAPPER: Record<string, string> = {
    CMD_insights: ServletCmds.INSIGHTS_HUB
}

export const SERVLET_COMMANDS_TO_ROUTE: Record<string, string> = {
    [ServletCmds.MFA_LOGIN]: MFA_ROUTE_PATH,
    [ServletCmds.TERMS_AND_CONDITIONS]: TERMS_AND_CONDITIONS_ROUTE_PATH,
    [ServletCmds.TEAMS_AUTH]: TEAMS_AUTH_ROUTE_PATH,
    [ServletCmds.INSIGHTS_HUB]: INSIGHTS_HUB_ROUTE_PATH
}
